import { PMChartTypeEnum } from '@/ship/Enums/ProjectManagementEnums';
import Http from '@/ship/Http';
import { GetRequestParams } from '@/ship/Requests/RequestParams';
import { ChartColumnEnum } from '@/ship/Enums/DynamicTableEnums';

export const sendChartVersionToApproval = (id: number, data: { approvalType?: number }) =>
    Http.post(`/project-management/chart-version/${id}/to-approval`, { ...data });

export const makeChartVersionCurrent = (id: number) =>
    Http.get(`/project-management/chart-versions/${id}/make-current`);

export const updateChartVersion = (id: number, data: any) => Http.put(`/project-management/chart-versions/${id}`, data);

export const getChartVersionPdf = (id: number) => Http.get(`/project-management/chart-versions/${id}/pdf`);

export const getChartVersionExcel = (id: number) => Http.get(`/project-management/chart-versions/${id}/excel`);

export const getChartVersionHistory = (id: number, params?: GetRequestParams) =>
    Http.get(`/project-management/chart-versions/${id}/history`, { params });

export const getChartColumnsPosition = (chartType: PMChartTypeEnum) =>
    Http.get(`/project-management/charts/${chartType}/column-position`);

export const setChartColumnsPosition = (chartType: PMChartTypeEnum, positionData: ChartColumnEnum[]) =>
    Http.post(`/project-management/charts/${chartType}/column-position`, { positionData });
